<template>
  <material-dialog
    title="Potwierdź zamknięcia formularza"
    text="Formularz zawiera niezapisane dane. Na pewno chcesz go zamknąć?"
    cancelText="Zostań"
    confirmText="Zamknij"
    :show="confirmDialog"
    :width="450"
    @close="$store.dispatch('hideConfirmDialog')"
    @confirm="$store.dispatch('confirm')"
  ></material-dialog>
</template>

<script>
import { mapState } from 'vuex';

import MaterialDialog from '@/components/material/Dialog';

export default {
  components: { MaterialDialog },
  data() {
    return {
      confirmDialog: false
    };
  },
  computed: {
    ...mapState({
      show: state => state.modalClose.show
    })
  },
  watch: {
    show(val) {
      this.confirmDialog = val;
    }
  }
};
</script>
